var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fe-flex"},[_c('div',{staticClass:"fe-text-heading-s fe-mb-xs"},[_vm._v(" "+_vm._s(_vm.averageRating)),_c('span',[_vm._v("/5")])]),_c('div',{staticClass:"fe-mb-xxs lg:fe-mb-xs"},[_c('StarRating',{attrs:{"readOnly":true,"initialRating":_vm.averageRating,"size":"s","partialSupport":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }